import React from "react";
import "./diarysystem.css";

function DiarySystem() {
  return (
    <div className="dataLogPageWrapper">

      <div className="dataLogPageContainer">

        {/* HEADER */}
        <div className="dataLogPageTitle">
          Nhật ký dữ liệu
        </div>

        <div className="dataLogPageBreadcrumb">
          Trang chủ / Nhật ký hệ thống / Nhật ký dữ liệu
        </div>

        {/* FILTER */}
        <div className="dataLogFilterContainer">

          {/* ROW 1 */}
          <div className="dataLogFilterGrid">

            {/* TIME */}
            <div className="dataLogFilterItem time-range">

              <label>Thời gian</label>

              <div className="dataLogDateRangeWrapper">

                <div className="dataLogDateBox">

                  <input
                    type="text"
                    value="20/05/2024 00:00"
                    readOnly
                  />

                  <i className="fa-regular fa-calendar"></i>

                </div>

                <span className="date-arrow">→</span>

                <div className="dataLogDateBox">

                  <input
                    type="text"
                    value="20/05/2024 23:59"
                    readOnly
                  />

                  <i className="fa-regular fa-calendar"></i>

                </div>

              </div>

            </div>

            {/* OBJECT */}
            <div className="dataLogFilterItem">

              <label>Đối tượng dữ liệu</label>

              <select>
                <option>-- Tất cả --</option>
              </select>

            </div>

            {/* ACTION */}
            <div className="dataLogFilterItem">

              <label>Loại thao tác</label>

              <select>
                <option>-- Tất cả --</option>
              </select>

            </div>

            {/* USER */}
            <div className="dataLogFilterItem">

              <label>Người thực hiện</label>

              <div className="search-box">

                <input
                  type="text"
                  placeholder="Nhập tên người dùng..."
                />

                <i className="fa-solid fa-magnifying-glass"></i>

              </div>

            </div>

            {/* RESULT */}
            <div className="dataLogFilterItem">

              <label>Kết quả</label>

              <select>
                <option>-- Tất cả --</option>
              </select>

            </div>

          </div>

          {/* ROW 2 */}
          <div className="dataLogFilterBottom">

            <div className="dataLogFilterItem small">

              <label>IP máy</label>

              <input
                type="text"
                placeholder="Nhập địa chỉ IP..."
              />

            </div>

            <div className="dataLogFilterItem note">

              <label>Ghi chú</label>

              <input
                type="text"
                placeholder="Nhập nội dung ghi chú..."
              />

            </div>

            <div className="dataLogActionButtonContainer">

              <button className="dataLogResetButton">

                <i className="fa-solid fa-rotate-left"></i>

                Đặt lại

              </button>

              <button className="dataLogSearchButton">

                <i className="fa-solid fa-magnifying-glass"></i>

                Tìm kiếm

              </button>

            </div>

          </div>

        </div>

        {/* TABLE HEADER */}
        <div className="dataLogTableHeader">

          <h3>Danh sách nhật ký dữ liệu</h3>

          <div className="dataLogExportButtonContainer">

            <button className="excel-btn">
              <i className="fa-regular fa-file-excel"></i>
              Export Excel
            </button>

            <button className="pdf-btn">
              <i className="fa-regular fa-file-pdf"></i>
              Export PDF
            </button>

            <button className="setting-btn">
              <i className="fa-solid fa-gear"></i>
            </button>

          </div>

        </div>

        {/* TABLE */}
        <div className="dataLogTableWrapper">

          <table className="dataLogTable">

            <thead>

              <tr>
                <th>STT</th>
                <th>Thời gian</th>
                <th>Người thực hiện</th>
                <th>Thao tác</th>
                <th>Đối tượng dữ liệu</th>
                <th>ID bản ghi</th>
                <th>Nội dung thay đổi</th>
                <th>IP máy</th>
                <th>Kết quả</th>
              </tr>

            </thead>

            <tbody>

              <tr>
                <td>1</td>
                <td>20/05/2024 14:32:15</td>
                <td>admin</td>

                <td>
                  <span className="badge create">
                    Thêm mới
                  </span>
                </td>

                <td>Doanh nghiệp</td>
                <td>DN000123</td>

                <td>
                  Thêm mới doanh nghiệp: Công ty TNHH ABC
                </td>

                <td>192.168.1.10</td>

                <td>
                  <span className="result success">
                    Thành công
                  </span>
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>20/05/2024 14:20:08</td>
                <td>nguyenvana</td>

                <td>
                  <span className="badge update">
                    Cập nhật
                  </span>
                </td>

                <td>Doanh nghiệp</td>
                <td>DN000118</td>

                <td>
                  Cập nhật thông tin doanh nghiệp
                  <br />
                  <span className="view-detail">
                    Xem chi tiết ↗
                  </span>
                </td>

                <td>192.168.1.12</td>

                <td>
                  <span className="result success">
                    Thành công
                  </span>
                </td>
              </tr>

              <tr>
                <td>3</td>
                <td>20/05/2024 13:15:47</td>
                <td>tranthibinh</td>

                <td>
                  <span className="badge delete">
                    Xóa
                  </span>
                </td>

                <td>Sản phẩm công nghiệp</td>
                <td>SP000567</td>

                <td>
                  Xóa sản phẩm: Máy bơm nước
                </td>

                <td>192.168.1.15</td>

                <td>
                  <span className="result success">
                    Thành công
                  </span>
                </td>
              </tr>

              <tr>
                <td>4</td>
                <td>20/05/2024 11:05:33</td>
                <td>lethicuc</td>

                <td>
                  <span className="badge update">
                    Cập nhật
                  </span>
                </td>

                <td>Báo cáo thống kê</td>
                <td>BC000245</td>

                <td>
                  Cập nhật báo cáo tháng 05/2024
                  <br />
                  <span className="view-detail">
                    Xem chi tiết ↗
                  </span>
                </td>

                <td>192.168.1.11</td>

                <td>
                  <span className="result success">
                    Thành công
                  </span>
                </td>
              </tr>

              <tr>
                <td>5</td>
                <td>20/05/2024 10:22:10</td>
                <td>admin</td>

                <td>
                  <span className="badge create">
                    Thêm mới
                  </span>
                </td>

                <td>Người dùng</td>
                <td>USER0156</td>

                <td>
                  Thêm mới người dùng: phamvanh
                </td>

                <td>192.168.1.10</td>

                <td>
                  <span className="result success">
                    Thành công
                  </span>
                </td>
              </tr>

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}
        <div className="dataLogPaginationContainer">

          <div className="pagination-left">

            Hiển thị

            <select>
              <option>10</option>
            </select>

            dòng trên mỗi trang

          </div>

          <div className="pagination-right">

            <span>1 - 10 trong 125</span>

            <button>«</button>
            <button>‹</button>

            <button className="active">
              1
            </button>

            <button>2</button>
            <button>3</button>

            <button>...</button>

            <button>13</button>

            <button>›</button>
            <button>»</button>

          </div>

        </div>

      </div>

    </div>
  );
}

export default DiarySystem;